/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { baseComponentManager } from '../../registry/Components';
import { ComponentManagerFn } from '../../registry/Component.type';
import { defaultValue } from './SidebarSpacer';

const SidebarSpacerManager: ComponentManagerFn<'SidebarSpacer'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'SidebarSpacer'>(platform, 'SidebarSpacer'),
    type: 'SidebarSpacer',
    name: 'Sidebar Spacer',
    defaultValue,
    props: {},
    getDisplayText: (item) => '',
    category: 'Sidebar',
    icon: { iconName: 'square' },
    description: `**Overview**<br/>
The Sidebar Spacer is a simple utility component used within a Sidebar Panel to manage vertical layout and whitespace. It inserts a flexible or fixed empty area between other sidebar elements, helping to visually separate distinct sections.
Use this component to push content to the bottom of the sidebar (like a "Log Out" button) or to create breathing room between a navigation menu and a user profile section.

**1. Configuration**<br/>
* **Zero Configuration:** This component requires no properties (props: {}). It functions purely as a structural filler. By default, it likely expands to fill available remaining space (acting like a flex-grow element) or provides a standard fixed height, depending on the sidebar's internal layout engine.

**2. Best Use Cases**<br/>
* **Bottom-Aligning Items:** Placing a spacer after the main navigation menu and before the footer elements ensures the footer (e.g., "Version 1.0" or "Sign Out") always stays at the very bottom of the panel, regardless of screen height.
* **Visual Separation:** Inserting a spacer between the "Main Menu" and "Admin Tools" sections to clearly distinguish them without using a hard line divider.`,
  };
};

export default SidebarSpacerManager;
